/**
 * The two filter rows above the Transaction History list: time range on the
 * left, ledger on the right.
 *
 * Split out of the card purely for size — it is presentational, and owns no
 * state of its own.
 */

import React from "react";
import {TimeFilter} from "@devour/client";
import {FaFire, FaGift} from "react-icons/fa";
import {RiVipDiamondLine} from "react-icons/ri";
import {MdCardGiftcard, MdReceipt} from "react-icons/md";
import {IoGameController} from "react-icons/io5";
import {TransactionFilter} from "./transactionHistoryTypes";

const TIME_FILTERS: Array<{ value: TimeFilter; label: string; title: string }> = [
    {value: TimeFilter.day, label: "D", title: "Today"},
    {value: TimeFilter.week, label: "W", title: "This Week"},
    {value: TimeFilter.month, label: "M", title: "This Month"},
    {value: TimeFilter.year, label: "Y", title: "This Year"},
    {value: TimeFilter.all, label: "All", title: "All Time"},
];

const LEDGER_FILTERS: Array<{ value: TransactionFilter; icon: React.ReactNode; title: string }> = [
    {value: "xp", icon: <RiVipDiamondLine/>, title: "XP Transactions"},
    {value: "gaming", icon: <IoGameController/>, title: "Gaming XP Transactions"},
    {value: "fuel", icon: <FaFire/>, title: "Fuel Transactions"},
    {value: "orders", icon: <MdReceipt/>, title: "Food & LootShop Orders"},
    {value: "lootbox", icon: <FaGift/>, title: "LootBox Rewards"},
    {value: "rewards", icon: <MdCardGiftcard/>, title: "LootShop Credit Rewards"},
];

interface TransactionHistoryFiltersProps {
    timeFilter: TimeFilter;
    onTimeFilterChange: (timeFilter: TimeFilter) => void;
    filter: TransactionFilter;
    onFilterChange: (filter: TransactionFilter) => void;
}

const TransactionHistoryFilters: React.FC<TransactionHistoryFiltersProps> = ({
    timeFilter,
    onTimeFilterChange,
    filter,
    onFilterChange,
}) =>
    <div className="transaction-history-card__filter-row">
        <div className="transaction-history-card__time-filters">
            {TIME_FILTERS.map((option) =>
                <button
                    key={option.value}
                    className={`transaction-history-card__time-filter ${timeFilter === option.value ? "active" : ""}`}
                    onClick={() => onTimeFilterChange(option.value)}
                    title={option.title}
                    aria-pressed={timeFilter === option.value}
                >
                    {option.label}
                </button>)}
        </div>

        <div className="transaction-history-card__filters">
            {LEDGER_FILTERS.map((option) =>
                <button
                    key={option.value}
                    className={`transaction-history-card__filter icon-only ${filter === option.value ? "active" : ""}`}
                    onClick={() => onFilterChange(option.value)}
                    title={option.title}
                    aria-label={option.title}
                    aria-pressed={filter === option.value}
                >
                    {option.icon}
                </button>)}
            <button
                className={`transaction-history-card__filter show-text ${filter === "all" ? "active" : ""}`}
                onClick={() => onFilterChange("all")}
                title="All Transactions"
                aria-pressed={filter === "all"}
            >
                All
            </button>
        </div>
    </div>;
export default TransactionHistoryFilters;
